import { type SxProps, type Theme } from '@mui/material';

// Same 32px page inset as the list views and ViewWrapperNew details views.
export const ViewWrapperStyles: SxProps<Theme> = {
  p: 4,
  width: '100%',
};

export const ViewWrapperPaperStyles: SxProps<Theme> = {
  alignItems: 'center',
  borderRadius: '8px',
  boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.05)',
  display: 'flex',
  flexDirection: 'column',
  height: '100%',
  justifyContent: 'center',
  padding: '3% 50px',
  width: '100%',
};
